import axios from './http'
var qs = require('qs');

//已发费用通知申请列表
export function httpFinanceList(page, limit, keyword) {
    let data = {
        page, limit, keyword
    }
    return axios({
        url: '/client/enterprise/record/index',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//汇款信息回显
export function httpRecordDetails(id) {
    let data = {
        id
    }
    return axios({
        url: '/client/enterprise/record/details',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//文件上传
export function httpUpload(data) {
    return axios({
        url: '/client/enterprise/record/upload',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: data
    })
}
//汇款信息填写
export function httpRecordSave(data) {
    return axios({
        url: '/client/enterprise/record/save',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//我的汇款记录
export function httpRecordList(page, limit, startTime, endTime) {
    let data = {
        page, limit, startTime, endTime
    }
    return axios({
        url: '/client/enterprise/record/record_list',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}
//我的汇款记录信息回显
export function httpMyRecordDetails(id) {
    let data = {
        id
    }
    return axios({
        url: '/client/enterprise/record/record_details',
        method: 'post',
        headers: {
            'token': sessionStorage.getItem('token')
        },
        data: qs.stringify(data)
    })
}